module.exports = __webpack_public_path__ + "static/media/vehicle1.b9618b25.svg";